var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_3778_17515)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3778_17515)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.06641,
    width: 55,
    height: 47,
    rx: 23.5,
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.875 24.8516C25.7383 24.9883 25.6836 25.1523 25.6836 25.3164C25.6836 25.5078 25.7383 25.6719 25.875 25.7812L29.5938 29.5C29.7031 29.6367 29.8672 29.6914 30.0586 29.6914C30.2227 29.6914 30.3867 29.6367 30.5234 29.5L31.125 28.8711C31.2344 28.7617 31.3164 28.5977 31.3164 28.4062C31.3164 28.2422 31.2344 28.0781 31.125 27.9414L28.5 25.3164L31.125 22.6641C31.2344 22.5547 31.3164 22.418 31.3164 22.2266C31.3164 22.0625 31.2344 21.8984 31.125 21.7617L30.5234 21.1328C30.3867 21.0234 30.2227 20.9414 30.0586 20.9414C29.8672 20.9414 29.7031 21.0234 29.5938 21.1328L25.875 24.8516Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3778_17515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 47.6888,
    fill: "white",
    transform: "translate(0 0.566406)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3778_17515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 48,
    fill: "white",
    transform: "translate(0 0.566406)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.65f875cd3d8f375f5614f5e6e0a39fd4.svg";
export { ForwardRef as ReactComponent };